import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const IMPACT_STYLE = {
  high: "text-[#FF453A]",
  medium: "text-[#FFD60A]",
  low: "text-white/50",
};

export default function CoreUpdatesPage() {
  const [updates, setUpdates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/core-updates");
      setUpdates(data.updates || []);
      setLoading(false);
    })();
  }, []);

  return (
    <div className="p-6 lg:p-10 max-w-5xl">
      <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-[#FF453A] mb-3">
        Timeline · Google
      </div>
      <h1 className="font-display text-4xl md:text-5xl font-black tracking-tight mb-4" data-testid="core-updates-title">
        Core Updates & mises à jour SERP.
      </h1>
      <p className="text-white/50 mb-12">
        Toutes les mises à jour Google confirmées (Core, Spam, Helpful Content, Product Reviews) avec impact et rollout.
      </p>

      {loading ? (
        <div className="text-white/40 font-mono text-sm">Chargement…</div>
      ) : (
        <div className="relative">
          {/* vertical line */}
          <div className="absolute left-4 top-2 bottom-2 w-px bg-white/10" />
          <div className="space-y-6">
            {updates.map((u) => (
              <div key={u.update_id} className="relative pl-12" data-testid={`core-update-${u.update_id}`}>
                <div className={`absolute left-[13px] top-3 w-2 h-2 ${IMPACT_STYLE[u.impact] || "text-white/50"} bg-current`} />
                <div className="border border-white/10 bg-[#121215] p-6 hover:border-white/20 transition-colors">
                  <div className="flex flex-wrap items-baseline gap-3 mb-2">
                    <span className="text-xs font-mono uppercase tracking-widest text-white/40">
                      {u.date}
                    </span>
                    <span className="text-[10px] font-mono uppercase tracking-widest text-white/60 border border-white/10 px-2 py-0.5">
                      {u.type}
                    </span>
                    <span className={`text-[10px] font-mono uppercase tracking-widest ${IMPACT_STYLE[u.impact]}`}>
                      Impact {u.impact}
                    </span>
                    <span className="text-[10px] font-mono uppercase tracking-widest text-white/40 ml-auto">
                      {u.status}
                    </span>
                  </div>
                  <h3 className="font-display text-2xl font-bold tracking-tight mb-2">
                    {u.name}
                  </h3>
                  <p className="text-white/60 leading-relaxed">{u.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
